export default "__VITE_ASSET__BuepiiAk__"